import { ChallengeFormat } from 'src/generated/graphql';
import { getI18n } from 'react-i18next';

export const getChallengeFormats = () => {
  const i18n = getI18n();
  return {
    [ChallengeFormat.Basic]: i18n.t('challenge-formats.basic', 'Basic'),
    [ChallengeFormat.TopScore]: i18n.t(
      'challenge-formats.top-score',
      'Top Score'
    ),
    [ChallengeFormat.Ladder]: i18n.t('challenge-formats.ladder', 'Ladder'),
  };
};

export const getChallengeFormat = (challenge: {
  __typename: string;
  challengeFormat: ChallengeFormat;
}) => {
  if (challenge.__typename !== 'Challenge') {
    return '--';
  }

  return getChallengeFormats()[challenge.challengeFormat];
};
